/**
 * Simple copy to clipboard utility with visual feedback
 */

/**
 * Copy text to clipboard with visual feedback
 * @param {string} text - Text to copy
 * @param {Function} setIconState - Function to update icon state
 * @param {string} itemKey - Unique key for this copy operation
 * @param {number} resetDelay - Time before resetting icon (default: 2000ms)
 */
export const copyToClipboard = async (text, setIconState, itemKey, resetDelay = 2000) => {
  try {
    await navigator.clipboard.writeText(text);
    setIconState(prev => ({ ...prev, [itemKey]: 'success' }));
    
    setTimeout(() => {
      setIconState(prev => ({ ...prev, [itemKey]: null }));
    }, resetDelay);
  } catch (err) {
    setIconState(prev => ({ ...prev, [itemKey]: 'error' }));
    
    setTimeout(() => {
      setIconState(prev => ({ ...prev, [itemKey]: null }));
    }, resetDelay);
    
    console.warn('Failed to copy to clipboard:', err);
  }
};

/**
 * Get the appropriate icon class based on state
 * @param {string} state - Current state: null, 'success', or 'error'
 * @returns {string} - FontAwesome icon class
 */
export const getCopyIcon = (state) => {
  if (state === 'success') return 'fa-check text-success';
  if (state === 'error') return 'fa-exclamation text-danger';
  return 'fa-copy';
};